import React, { useState, useEffect, useContext } from "react";
import axios from 'axios';
import { Link, useLocation, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { StyledMember, StyledPanel } from '../stylesheets/styles';
import { API_URL } from '../common/constants';
import BgComponent from '../components/BgComponent';
import AuthContext from '../contexts/AuthContext';
import ModalContext from '../contexts/ModalContext';
import Modal from 'react-bootstrap/Modal';

const Payment = () => {
  const { 
      register, 
      watch,
      setValue,
      formState: { errors, isSubmitting }
    } = useForm();

  const { isAuth } = useContext(AuthContext);
  const { handleShow } = useContext(ModalContext);
  const { batteryId } = useParams(); // 獲取 batteryId 參數
  // 取得 url search 參數
  const searchParams = new URLSearchParams(window.location.search);
  const serialNo = searchParams.get('serialNo');
  // clientUrl 設定為 batteries 頁面
  const clientUrl = `${window.location.origin}/battery`;
  // 設定電池錯誤詢息彈窗
  const [showMsgModal, setShowMsgModal] = useState(false);
  const [errormsg, setErrormsg] = useState('');
  const handleCloseMsgModal = () => setShowMsgModal(false);
  const handleShowMsgModal = () => setShowMsgModal(true);
  
  useEffect(() => {
    if (!isAuth) {
      console.error('No token found');
      handleShow();
      return;
    }
    const fetchPaymentSettings = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          console.error('No token found');
          handleShow();
          return;
        }
        const response = await axios.post(`${API_URL}/api/payment`, {
          BatteryId: batteryId,
          ClientUrl: clientUrl
        }, {
          headers: {
            Authorization: `Bearer ${token}`,
            ContentType: 'application/x-www-form-urlencoded'
          }
        });
  
        if (response.status === 401 || response.status === 500) {
          handleShow();
          return;
        }
  
        if (response.data.isSuccess) {
          const paymentSetting = response.data.result;
          setValue('MerchantID', paymentSetting.merchantId);
          setValue('TradeInfo', paymentSetting.tradeInfo);
          setValue('TradeSha', paymentSetting.tradeSha);
          document.forms[0].action = paymentSetting.paymentUrl;
        } else {
          console.error('Error fetching payment settings:', response.data.message);
          setErrormsg(response.data.message);
          handleShowMsgModal();
        }        
      } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 500)) {
          handleShow();
        } else {
          console.error('Error submitting payment:', error);
        }
      }
    };
    if (isAuth) {
      fetchPaymentSettings();
    }

  }, [setValue, batteryId, isAuth]);
  
  return (
    <StyledMember className='register'>
      <div className='member-wrap'>
        <Container>
          <Row className="justify-content-md-center">
            <Col xl="7" lg="10" md="12">
            <StyledPanel>
                <div className="hgroup">
                  <h1 className="text-center">確認付款</h1>
                </div>
                <Form method="post" action="">
                  <div className="form-group">
                    <label className="form-label visually-hidden" htmlFor="MerchantID">MID:</label>
                    <input 
                      {...register("MerchantID")} type="hidden" name="MerchantID" id="MerchantID" 
                      className={`form-control ${errors.MerchantID ? "is-invalid" : ""}`}
                    />
                  </div>
                  <div>
                    <input 
                      {...register("Version")} type="hidden" name="Version" id="Version" value="2.0" readOnly 
                      className={`form-control ${errors.Version ? "is-invalid" : ""}`}
                    />
                  </div>
                  <div>
                    <input 
                      {...register("TradeInfo")} type="hidden" name="TradeInfo" id="TradeInfo" readOnly 
                      className={`form-control ${errors.TradeInfo ? "is-invalid" : ""}`}
                    />
                  </div>
                  <div>
                    <input 
                      {...register("TradeSha")} type="hidden" name="TradeSha" id="TradeSha" readOnly 
                      className={`form-control ${errors.TradeSha ? "is-invalid" : ""}`}
                    />
                  </div>
                  <div className="mb-4">
                    <p className="text-center mb-1">
                      您選擇付款的電池 ID 是：{serialNo}
                    </p>
                    {errormsg && (
                      <div className="text-center">
                        <small className="text-danger ">
                          {errormsg}
                        </small>
                      </div>
                    )}
                  </div>
                  <div className="col-md-8 mx-auto">
                    <Button variant="secondary" size="lg" className="action-btn w-100" type="submit">
                      送出交易
                    </Button>
                    <div className="text-center mt-4">
                      <Link className='text-center text-muted' to='/battery' >返回我的電池列表</Link>
                    </div>
                  </div>
                </Form>
              </StyledPanel>
            </Col>
          </Row>
        </Container>
        <BgComponent/>
      </div>
      <Modal show={showMsgModal} onHide={handleCloseMsgModal}>
        <Modal.Header closeButton>
          <Modal.Title className="text-center w-100"></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className='text-center my-4' style={{maxWidth: '280px', margin: '0 auto'}}>
            {errormsg}
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => window.location.href = '/battery'}>
            返回
          </Button>
        </Modal.Footer>
      </Modal>
    </StyledMember>
  );
};

export default Payment;